import { render } from "./Department-details.vue?vue&type=template&id=0c19379a&scoped=true"
import script from "./Department-details.vue?vue&type=script&lang=js"
export * from "./Department-details.vue?vue&type=script&lang=js"

import "./Department-details.vue?vue&type=style&index=0&id=0c19379a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c19379a"

export default script